import {
  Artist,
  ARTIST_CATEGORY,
  ArtistCategory,
  ArtistRegisterStatus,
  ArtistStatus,
} from '@favid-inc/api';
import { Option, SelectInput } from 'core/form';
import { Action } from 'core/generic';
import React from 'react';
import { request as client } from 'utils';
import { Loading } from 'utils';
import { updateArtist } from '../management';

interface Props {
  artist: Artist;
  dispatch: (action: Action) => void;
}

const artistRegisterStatusOptions: Option[] = [
  {
    label: 'Aprovado',
    value: ArtistRegisterStatus.APPROVED,
    name: 'registerStatus',
  },
  {
    label: 'Negado',
    value: ArtistRegisterStatus.DENIED,
    name: 'registerStatus',
  },
  {
    label: 'Pendente',
    value: ArtistRegisterStatus.PENDING,
    name: 'registerStatus',
  },
];

const artistStatusOptions: Option[] = [
  { label: 'Ativo', value: ArtistStatus.ACTIVE, name: 'status' },
  { label: 'Bloqueado', value: ArtistStatus.BLOCKED, name: 'status' },
  { label: 'Inativo', value: ArtistStatus.INACTIVE, name: 'status' },
  { label: 'Banido', value: ArtistStatus.OUTCAST, name: 'status' },
];

export class ArtistForm extends React.Component<Props> {
  state = {
    isLoading: true,
    isSubmitingForm: false,
    artist: this.props.artist,
    categories: [] as Option[],
  };

  async componentDidMount() {
    const request = {
      url: `/${ARTIST_CATEGORY}`,
      method: 'GET' as 'GET',
    };
    const response = await client.request<ArtistCategory[]>(request);
    const categories: Option[] = response.data.map((categorie) => ({
      label: categorie,
      value: categorie,
      name: 'categories',
    }));

    this.setState({
      isLoading: false,
      categories,
    });
  }

  onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (this.state.isSubmitingForm) {
      return;
    }

    this.setState({ isSubmitingForm: true });
    await updateArtist(this.state.artist, this.props.dispatch);
    this.setState({ isSubmitingForm: false });
  };

  onChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >,
  ) => {
    const { target } = event;
    const key = target.dataset.value;

    if (!key) {
      return;
    }

    const value = target.type === 'checkbox' ? (target as HTMLInputElement).checked : target.value;

    this.setState({
      artist: {
        ...this.state.artist,
        [key]: value,
      },
    });
  };

  onSelectChange = (valueType: any) => {
    if (valueType.name) {
      this.setState({
        artist: { ...this.state.artist, [valueType.name]: valueType.value },
      });
      return;
    }

    const values = valueType.map((item: { value: string }) => item.value);
    this.setState({
      artist: { ...this.state.artist, [valueType[0].name]: values },
    });
  };

  render() {
    const { artist, categories, isLoading } = this.state;

    if (isLoading) {
      return <Loading />;
    }

    const loadingStyle = this.state.isSubmitingForm ? 'loading' : '';

    const mainCategories = categories.map((item) => ({
      ...item,
      name: 'mainCategory',
    }));

    return (
      <form className='ui form' onSubmit={this.onSubmit}>
        <br />
        <div className='field'>
          <div className='ui toggle checkbox'>
            <input
              id='input-artist-featured'
              type='checkbox'
              onChange={this.onChange}
              data-value='featured'
              checked={artist.featured ?? false}
            />
            <label htmlFor='input-artist-featured' style={{ cursor: 'pointer' }}>
              Destaque
            </label>
          </div>
        </div>
        <div className='two fields'>
          <div className='field'>
            <label>Nome Artistico</label>
            <input
              onChange={this.onChange}
              data-value='artisticName'
              value={artist.artisticName || ''}
            />
          </div>
          <div className='field'>
            <label>E-mail</label>
            <input
              readOnly={true}
              onChange={this.onChange}
              data-value='email'
              value={artist.email || ''}
            />
          </div>
        </div>
        <div className='two fields'>
          <div className='field'>
            <label>Telefone</label>
            <input
              onChange={this.onChange}
              data-value='phoneNumber'
              value={artist.phoneNumber || ''}
            />
          </div>
          <div className='field'>
            <label>Localização</label>
            <input
              onChange={this.onChange}
              data-value='location'
              value={artist.location || ''}
            />
          </div>
        </div>
        <div className='two fields'>
          <div className='field'>
            <label>Preço</label>
            <input
              readOnly={true}
              onChange={this.onChange}
              data-value='price'
              value={artist.price || ''}
            />
          </div>
        </div>
        <div className='two fields'>
          <div className='field'>
            <SelectInput
              form=''
              name='registerStatus'
              data-value='registerStatus'
              label='Status de cadastro'
              selected={artist.registerStatus}
              options={artistRegisterStatusOptions}
              onChange={this.onSelectChange}
            />
          </div>
          <div className='field'>
            <SelectInput
              form=''
              name='status'
              data-value='status'
              label='Status do artista'
              selected={artist.status}
              options={artistStatusOptions}
              onChange={this.onSelectChange}
            />
          </div>
        </div>
        <div className='two fields'>
          <div className='field'>
            <SelectInput
              form=''
              name='mainCategory'
              label='Categoria Principal'
              selected={artist.mainCategory}
              options={mainCategories}
              onChange={this.onSelectChange}
            />
          </div>
          <div className='field'>
            <SelectInput
              form=''
              isMulti={true}
              name='categories'
              label='Categorias'
              selected={artist.categories}
              options={categories}
              onChange={this.onSelectChange}
            />
          </div>
        </div>
        <div className='field'>
          <label>Sobre</label>
          <textarea
            data-value='biography'
            onChange={this.onChange}
            value={artist.biography || ''}
          />
        </div>
        <button
          type='submit'
          className={`ui button primary blue ${loadingStyle}`}
        >
          Enviar
        </button>
      </form>
    );
  }
}
